import styled from "styled-components";
import { colors2, clampText, CheckboxButton } from "oolib";

const { grey10, grey5, grey50 } = colors2;

const checkboxHoverOnParent = `
  &:hover .radioOrCheckboxButton_inside_input {
    border-color: ${grey50};
    &::before {
      background: ${grey10};
    }
  }
`;

const textLineClamp = 2;
const descriptionLineClamp = 3;

export const StyledListItemWrapper = styled.li`
  display: flex;
  align-items: center;
  /*padding: ${({ S }) => (S ? "0.8rem 1rem" : "1rem" )};*/
  min-height: 3.4rem;
  padding: 0.8rem 1rem; 
  border-radius: 0.4rem;
  gap: 1rem;

  justify-content: space-between;

  background-color: ${({ isFocussed, isSelected, secondaryContainerColor }) => {
    if (isSelected) {
      return `${secondaryContainerColor} !important`;
    } else {
      return isFocussed ? colors2.grey5 : colors2.white;
    }
  }};

  .OKE-Dropdown__optionText {
    color: ${colors2.grey80};
  }

  .OKE-Dropdown__optionIcon {
    color: ${colors2.grey80};
  }

  &:hover {
    background-color: ${({ theme }) => `${grey5}`};
  }

  ${checkboxHoverOnParent}

  &:first-of-type {
    /* margin-top: 0.4rem; */
  }

  &:last-of-type {
    /* margin-bottom: 0.4rem; */
  }

  .OKE-Dropdown__optionDesc {
    ${clampText(descriptionLineClamp)}
    white-space: normal;
  }

  .OKE-Dropdown__optionImg {
    flex: 0 0 auto;
  }

  .OKE-Dropdown__checkboxClickArea {
    position: absolute;
    width: 2rem;
    height: 2rem;
  }
  .OKE-Dropdown__checkboxClickArea-box {
    margin-top: 0.2rem;
    flex-shrink: 0;
  }
`;

export const StyledCheckboxArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0.4rem;
  flex: none;
  padding: 0 1rem;
  height: 3.4rem;

  &:hover {
    background-color: ${grey10};
  }

  ${checkboxHoverOnParent}
`;

export const StyledRightSection = styled.div`
  margin-top: 0.1rem;
  display: flex;
  gap: 0.5rem;
  align-self: flex-start;
  justify-content: space-between;
  height: 100%;
`;

export const StyledSmallCheckbox = styled(CheckboxButton)`
  width: 1.6rem;
  height: 1.6rem;
`;

export const StyledWrapper = styled.div`
  overflow: hidden;
  min-width: 0;
  flex: 1;

  /* Ensure direct child divs can shrink below content width */
  > div {
    min-width: 0;
  }

  .OKE-Dropdown__optionText {
    ${clampText(textLineClamp)}
    white-space: normal;
  }
`;
